import { ToastProvider } from '@ui';
import { QueryClientProvider } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { RouterProvider } from 'react-router';
import { OfflineStatus } from '../features/offline/OfflineStatus';
import { queryClient } from '../lib/queryClient';
import { router } from './router';

export function App() {
  const { t } = useTranslation();
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider dismissLabel={t('common.dismiss')}>
        <RouterProvider router={router} />
        <OfflineStatus />
      </ToastProvider>
    </QueryClientProvider>
  );
}
